import { FileText, ImageIcon } from 'lucide-react';
import type { Attachment } from './attachment';
import { useBlobUrl } from './use-blob-url';

type AttachmentThumbProps = {
  readonly attachment: Attachment;
};

export function AttachmentThumb({ attachment }: AttachmentThumbProps) {
  const isImage = attachment.type.startsWith('image/');
  const url = useBlobUrl(isImage ? attachment.sha256 : undefined);
  if (isImage && url)
    return <img src={url} alt="" className="size-10 shrink-0 rounded-md border object-cover" />;
  const Icon = isImage ? ImageIcon : FileText;
  return (
    <span className="flex size-10 shrink-0 items-center justify-center rounded-md border bg-muted">
      <Icon className="size-4 text-muted-foreground" />
    </span>
  );
}
